module.exports = __webpack_public_path__ + "img/video.f3a7888.webp";